import { render, staticRenderFns } from "./ReportsDevice.vue?vue&type=template&id=b18f4d2a&scoped=true"
import script from "./ReportsDevice.vue?vue&type=script&lang=js"
export * from "./ReportsDevice.vue?vue&type=script&lang=js"
import style0 from "./ReportsDevice.vue?vue&type=style&index=0&id=b18f4d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f4d2a",
  null
  
)

export default component.exports